module.exports = __webpack_public_path__ + "static/media/1124_WarpWeighted_1K.04213835.glb";